// @flow
import * as React from "react"
import {Redirect} from "react-router"
import {containers} from "@swarm2/core"
import * as Util from "../common"

function RedirectCharacter(props) {
  const {isEmpty, isError, charId} = props
  if (isEmpty) return <Redirect to="/me/characters" />
  if (isError) return <Util.Error error={props} />
  return <Redirect to={"/p/" + charId} />
}
export const RedirectLastCharacter = containers.characters.LastCharacter(
  RedirectCharacter,
)
export const Start = containers.app.Start(RedirectCharacter)



// WEBPACK FOOTER //
// ./src/characters/RedirectLastCharacter.js